
import Bugsnag from '@bugsnag/js'
import { DateTime } from "luxon"

/**
 * Pass in a couple object (Wedding model)
 * Returns tax percent
 */
const getTaxPercent = couple => {
    let provinceId;
    if (couple.officiant && couple.officiant.province_id !== null) {
        provinceId = couple.officiant.province_id;
    } else if (couple.couple_province_id !== null) {
        provinceId = couple.couple_province_id;
    }
    if (provinceId == 1) {
        return 0.05;
    } else if (provinceId == 46) {
        return 0.13;
    }
    return 0;
}

const getTimesList = (ampm, i) => {
    const hours = [12,1,2,3,4,5,6,7,8,9,10,11];
    const subTimes = ['00','15','30','45'];
    let index = i;
    let times = [];
    hours.map(hour => {
        let prefix = ampm === 'am' ? hour : (12 + hour);
        if (hour === 12) {
            prefix = ampm == 'am' ? '0' : '12';
        }
        let list = [];
        subTimes.map(val => {
            list = list.concat(
                { id: index, value: `${prefix}:${val}`, name: `${hour}:${val} ${ampm}` }
            )
            index += 1;
        });
        times = times.concat(list);
    });
    return times;
}

const getPickerTimes = () => {
    return getTimesList('am', 0).concat(getTimesList('pm', 48));
}

const getTimeZone = (dateStr) => {
    const date = new Date(dateStr).toString();
    const luxonDate = DateTime.fromISO(new Date(dateStr).toISOString());

    try {
        return {
            name: luxonDate.toFormat('ZZZZZ'),
            initials: luxonDate.toFormat('ZZZZ'),
            zone: luxonDate.toFormat('z')
        };
    } catch (e) {
        Bugsnag.notify(e, function (event) {
            event.addMetadata('debugging', {
                dateStr,
                date
            })
        });
        return {
            name: 'Eastern Daylight Time',
            initials: 'EDT',
            zone: 'America/Toronto'
        };
    }
}

const getGoogleMapsLink = (string) => {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURI(string)}`;
}

const uppercaseFirstLetter = string => {
    return string ? string[0].toUpperCase() + string.substring(1) : '';
}

const couplePronouns = couple => {
    return {
        bride: uppercaseFirstLetter(couple.bride_title) || 'Bride',
        groom: uppercaseFirstLetter(couple.groom_title) || 'Groom',
    };
}

const nonPronouns = () => {
    return {
        bride: 'Applicant',
        groom: 'Joint Applicant'
    }
}

export {
    getTaxPercent,
    getPickerTimes,
    getTimeZone,
    getGoogleMapsLink,
    uppercaseFirstLetter,
    couplePronouns,
    nonPronouns
}
